import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { align: "right" }

import { useModelWrapper } from './wrappers/helpers/useModelWrapper'
import { useI18n } from 'vue-i18n'
import BaseModal from './wrappers/BaseModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalPromptDelete',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["confirmDelete", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const value = useModelWrapper(props, emit)

const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)

const confirmDelete = () => {
  emit('confirmDelete')
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(BaseModal, {
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
  }, {
    title: _withCtx(() => [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createTextVNode(_toDisplayString(label('promptDeleteActivityHeader')), 1)
      ])
    ]),
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "content", {}, () => [
        _createTextVNode(_toDisplayString(label('promptDeleteActivity')), 1)
      ])
    ]),
    actions: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createVNode(_component_q_btn, {
          flat: "",
          "no-caps": "",
          class: "text-grey-7",
          label: label('cancel')
        }, null, 8, ["label"]), [
          [_directive_close_popup]
        ]),
        _withDirectives(_createVNode(_component_q_btn, {
          onClick: confirmDelete,
          flat: "",
          "no-caps": "",
          class: "text-negative",
          label: label('delete')
        }, null, 8, ["label"]), [
          [_directive_close_popup]
        ])
      ])
    ]),
    _: 3
  }, 8, ["modelValue"]))
}
}

})